import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=356089d6&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=356089d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356089d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356089d6')) {
      api.createRecord('356089d6', component.options)
    } else {
      api.reload('356089d6', component.options)
    }
    module.hot.accept("./TheSidebar.vue?vue&type=template&id=356089d6&scoped=true", function () {
      api.rerender('356089d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheSidebar.vue"
export default component.exports